// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zge4","col":"styles_col__jZpfl"};